import { type FilterData } from '../../filters/Filters'

export function prepareSmartFilterParams(
  hash: string,
  defaultParams: { [code: string]: string|string[]},
  smartFilterParams?: FilterData[],
) {
  const params = { ...defaultParams }

  if (smartFilterParams) {
    smartFilterParams.forEach((param) => {
      if (param.column && param.column.hash === hash) return

      const val = Array.isArray(param.value) ? param.value.map((v) => String(v)) : String(param.value)

      params[param.code] = params[param.code]
        ? [
          ...(Array.isArray(params[param.code]) ? params[param.code] : [params[param.code]]),
          ...(Array.isArray(val) ? val : [val]),
        ] as string[]
        : val
    })
  }

  return params
}
